import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {Part, PartType} from '../../../models/Part';
import {v4} from 'uuid';
import {DetailDistancePart} from './DetailDistancePart';
import {DetailDurationPart} from './DetailDurationPart';
import {DetailRestPart} from './DetailRestPart';
import {DetailOffErgPart} from './DetailOffErgPart';
import {DetailRepetitionsPart} from './DetailRepetitionsPart';

interface OwnProps {
    type: PartType;
    onAdd: (part: Part) => void;
    onDismiss: () => void;
}

function initialPart(partType: PartType): Part {
    switch (partType) {
        case PartType.Distance:
            return {
                __uuid: v4(),
                type: PartType.Distance,
                is_preview: false,
                distance_meters: 500,
                device_identifier: null,
            };
        case PartType.Duration:
            return {
                __uuid: v4(),
                type: PartType.Duration,
                is_preview: false,
                duration_milliseconds: 1000 * 60 * 5, //5 minutes
                device_identifier: null,
            };
        case PartType.Repetitions:
            return {
                __uuid: v4(),
                type: PartType.Repetitions,
                is_preview: false,
                repetitions: 10,
                device_identifier: null,
            };
        case PartType.Rest:
            return {
                __uuid: v4(),
                type: PartType.Rest,
                is_preview: false,
                rest_milliseconds: 1000 * 30, //30 seconds
                device_identifier: null,
            };
        case PartType.OffErg:
            return {
                __uuid: v4(),
                type: PartType.OffErg,
                is_preview: false,
                duration_milliseconds: 1000 * 60 * 5, //5 minutes
                instruction_text: '',
                device_identifier: null,
            };
    }
}

export const DetailPart: FunctionComponent<OwnProps> = ({type, onAdd, onDismiss}) => {
    const [part, setPart] = useState(initialPart(type));

    function getContent(): JSX.Element {
        switch (part.type) {
            case PartType.Distance:
                return <DetailDistancePart part={part} onChange={setPart} />;
            case PartType.Duration:
                return <DetailDurationPart part={part} onChange={setPart} />;
            case PartType.Repetitions:
                return <DetailRepetitionsPart part={part} onChange={setPart} />;
            case PartType.Rest:
                return <DetailRestPart part={part} onChange={setPart} />;
            case PartType.OffErg:
                return <DetailOffErgPart part={part} onChange={setPart} />;
        }
    }

    return (
        <>
            <div className="modal-header">
                <h2>Configure part</h2>
            </div>
            <div className="modal-body">{getContent()}</div>
            <div className="modal-footer">
                <button className="btn btn-primary pull-right" onClick={() => onAdd(part)}>
                    Add
                </button>
                <button className="btn btn-secondary pull-right" onClick={onDismiss}>
                    Cancel
                </button>
            </div>
        </>
    );
};
